module.exports = __webpack_public_path__ + "static/img/5.ffd2bd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/5.png
// module id = mve7
// module chunks = 12